module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 
var map = control.map.map;

    ; __append("\n<div class=\"gis-layers-control absolute gl-pointer\">\n    <div class=\"icon\">\n        <div class=\"icon-20 icon-map\"></div>\n    </div>\n    <div name=\"selector\" class=\"absolute selector\">\n        <div class=\"table\">\n            ")
    ;  Util.each(control.groups, function (group, groupIndex) { 
    ; __append("\n                ")
    ;  if (groupIndex>0) { 
    ; __append("<hr/>")
    ;  } 
    ; __append("\n                ")
    ;  if (group.title) { 
    ; __append("<h4>")
    ; __append(escapeFn( group.title ))
    ; __append("</h4>")
    ;  } 
    ; __append("\n                ")
    ;  Util.each(group.items, function (item, itemIndex) { 
    ; __append("\n                    <div base=\"")
    ; __append(escapeFn( item.title ))
    ; __append("\">\n                        <div style=\"padding-right: 5px;\">\n\n                            <label class=\"nowrap\">\n                                <input type=\"radio\" name=\"")
    ; __append(escapeFn( control.uuid ))
    ; __append("\" ")
    ;  if (item.active) { 
    ; __append("checked=\"checked\"")
    ;  } 
    ; __append(" data-group=\"")
    ; __append(escapeFn( groupIndex ))
    ; __append("\" data-item=\"")
    ; __append(escapeFn( itemIndex ))
    ; __append("\" on-click=\"onItemSelect\" ")
    ; __append(escapeFn( item.switchable ? "" : "disabled" ))
    ; __append(">\n                                <span cell=\"title\" style=\"padding-right: 5px;\">")
    ; __append(escapeFn( Util.coalesce(item.title, name) ))
    ; __append("</span>\n                            </label>\n                        </div>\n                        <div>\n                            ")
    ;  if (item.widget) { 
    ; __append("\n                            <div class=\"icon-16 icon-settings gl-pointer\" data-group=\"")
    ; __append(escapeFn( groupIndex ))
    ; __append("\" data-item=\"")
    ; __append(escapeFn( itemIndex ))
    ; __append("\" on-click=\"onWidgetClick\"></div>\n                            ")
    ;  }; 
    ; __append("\n                        </div>\n                    </div>\n                ")
    ;  }) 
    ; __append("\n            ")
    ;  }) 
    ; __append("\n        </div>\n    </div>\n</div>\n")
  }
  return __output.join("");

}